// Auto-generated version file for cache busting
// This file is updated on each build to ensure fresh content
export const APP_VERSION = '2.0.0';
export const BUILD_TIMESTAMP = new Date().toISOString();
export const BUILD_HASH = Date.now().toString(36);

// Check if running latest version
export function checkVersion() {
  const stored = localStorage.getItem('app_version');
  if (stored !== APP_VERSION) {
    console.log(`New version detected: ${APP_VERSION} (was: ${stored})`);
    localStorage.setItem('app_version', APP_VERSION);
    return false; // Version changed
  }
  return true; // Same version
}

// Clear all caches and reload
export function forceClearCache() {
  // Clear localStorage except user preferences
  const preserve = ['user_preferences', 'auth_token'];
  const preserved: Record<string, string> = {};
  preserve.forEach(key => {
    const value = localStorage.getItem(key);
    if (value) preserved[key] = value;
  });

  localStorage.clear();

  // Restore preserved items
  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });

  // Clear session storage
  sessionStorage.clear();

  // Unregister service workers
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => reg.unregister());
    });
  }

  // Clear cache storage
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => caches.delete(name));
    });
  }

  // Reload with cache bypass
  window.location.reload();
}
